import instagramIcon from "@images/black-ic-inst.svg"
import linkedinIcon from "@images/black-ic-linkedin.svg"
import facebookIcon from "@images/black-ic-facebook.svg"

export const NAVIGATIONAL_MENU_OFFSET = 540;

export const FILTER_OPTIONS = [
    "Telecom",
    "Proptech",
    "Healthtech",
    "Edtech",
    "AI",
    "Startups",
    "Tech",
    "Business",
    "Impressit Life"
];

export const HUGE_LIKE_BUTTON_TEXT_OPTIONS = [
    "Click me...",
    "...baby..",
    "...one more time...",
    "Thank You! ;)"
];